export default __webpack_public_path__ + "static/media/crypto-1.9c1de029.PNG";